// TalentReef platform-level analytics: Google Analytics + Google Tag Manager.
// These IDs are platform-wide (not client-configured) and were previously loaded
// by an inline gate in public/index.html. That gate ran only once before React
// and could not read the per-client consent cookie, so it is now loaded here so
// the feature-flag + per-client-consent logic lives in a single reactive place.
const PLATFORM_GA_ID = 'UA-107917000-1'
const PLATFORM_GTM_ID = 'GTM-WCT7GRX'

let loaded = false

// Idempotent: safe to call multiple times (on flag resolve, on consent update,
// on re-render). It only injects the scripts once per page load.
export function loadPlatformAnalytics() {
  if (loaded || typeof document === 'undefined') {
    return
  }
  loaded = true

  // Global site tag (gtag.js) - Google Analytics
  const gaScript = document.createElement('script')
  gaScript.async = true
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${PLATFORM_GA_ID}`
  document.head.appendChild(gaScript)
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', PLATFORM_GA_ID)

  // Google Tag Manager
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', PLATFORM_GTM_ID)
}

// Exposed for tests to reset the module-level guard between cases.
export function __resetPlatformAnalyticsForTest() {
  loaded = false
}

export { PLATFORM_GA_ID, PLATFORM_GTM_ID }
